//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RouteConstants } from '../../Constants/routeConstants';
import { useAppSelector } from '../../Hooks';
import { CenterSection } from '../../Layouts/LayoutSections/MidSection';
import CreatePostSec from '../PageDetails/createPost/index';
import { pageDetailThunk, pageGetGallleryThunk } from '../../Redux/thunks/pageDetailThunk';
import Loader from '../Loader/Loader';
import CreatePost from '../Modals/CreatePost/CreatePost';
import CreateArticle from '../Modals/CreateArticle/CreateArticle';
import Carousel from 'react-elastic-carousel';
import './ProfilePage.scss';
import { setPopup, setSidePanel } from '../../Redux/slices/metaSlice';
import { addPageAction, setActiveSideSlug, type pageDetailData, loadPageDetail } from '../../Redux/slices/pageDetailSlice';
import SidePanel from '../SidePanel/SidePanel';
import { createdBytimeSince, InviteparseURLParams, parseURLParams } from '../../commonservice';

interface ProfilePageProps {
  // No props needed since we'll get pageUrl from URL params and Redux state
}

const profileQuestions = [
  {
    id: 1,
    original: "Who was the biggest influence in your life?",
    firstPerson: "Who was the biggest influence in my life?",
    defaultAnswer: "I was deeply influenced by..."
  },
  {
    id: 2,
    original: "What major event or realization shaped who you are?",
    firstPerson: "What major event or realization shaped who I am?",
    defaultAnswer: "A pivotal moment in my life was..."
  },
  {
    id: 3,
    original: "Who was your closest friend growing up?",
    firstPerson: "Who was my closest friend growing up?",
    defaultAnswer: "My closest childhood friend was..."
  },
  {
    id: 4,
    original: "What was the most important lesson you learned as a parent?",
    firstPerson: "What was the most important lesson I learned as a parent?",
    defaultAnswer: "The most valuable parenting lesson I learned..."
  },
  {
    id: 5,
    original: "What is the best advice you could give your child?",
    firstPerson: "What is the best advice I could give my child?",
    defaultAnswer: "The most important advice I would give is..."
  },
  {
    id: 6,
    original: "What phrase has kept you afloat during hard times?",
    firstPerson: "What phrase has kept me afloat during hard times?",
    defaultAnswer: "The words that helped me through difficult times..."
  },
  {
    id: 7,
    original: "What advice do you have about growing older?",
    firstPerson: "What advice do I have about growing older?",
    defaultAnswer: "My perspective on aging is..."
  },
  {
    id: 8,
    original: "What are some of your favorite memories growing up?",
    firstPerson: "What are some of my favorite memories growing up?",
    defaultAnswer: "My cherished childhood memories include..."
  },
  {
    id: 9,
    original: "When life was difficult, what did you do to overcome it?",
    firstPerson: "When life was difficult, what did I do to overcome it?",
    defaultAnswer: "I overcame life's challenges by..."
  },
  {
    id: 10,
    original: "What is one thing you haven't done you regret?",
    firstPerson: "What is one thing I haven't done I regret?",
    defaultAnswer: "One regret I carry is..."
  },
  {
    id: 11,
    original: "What are you most proud of having done in life?",
    firstPerson: "What am I most proud of having done in life?",
    defaultAnswer: "My proudest achievement is..."
  },
  {
    id: 12,
    original: "Do you have any superstitions?",
    firstPerson: "Do I have any superstitions?",
    defaultAnswer: "When it comes to superstitions..."
  },
  {
    id: 13,
    original: "What do you hold sacred?",
    firstPerson: "What do I hold sacred?",
    defaultAnswer: "The things I hold most sacred are..."
  },
  {
    id: 14,
    original: "Did you have a nickname? What is the story behind it?",
    firstPerson: "Did I have a nickname? What is the story behind it?",
    defaultAnswer: "The story of my nickname..."
  },
  {
    id: 15,
    original: "If you could redo any period in your life, what would it be and why?",
    firstPerson: "If I could redo any period in my life, what would it be and why?",
    defaultAnswer: "If I could go back in time..."
  },
  {
    id: 16,
    original: "What is your favorite compliment to receive? Why?",
    firstPerson: "What is my favorite compliment to receive? Why?",
    defaultAnswer: "The compliment that means the most to me..."
  }
];

const ProfilePage: React.FC<ProfilePageProps> = () => {
  const { pageUrl } = useParams();  // Changed from pageId
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userState = useAppSelector(state => state.user);
  const pageDetailState = useAppSelector(state => state.pagedetail.data);
  const appMeta = useAppSelector(state => state.metadata);
  const isLoggedIn = !!userState?.value?.data?._id;
  const isPageOwner = isLoggedIn && userState?.value?.data?._id === pageDetailState?.belongsTo;

  // Debug log to verify ownership logic
  console.log('Profile Page Access:', {
    isLoggedIn,
    userId: userState?.value?.data?._id,
    pageOwner: pageDetailState?.belongsTo,
    isPageOwner
  });
  const [answers, setAnswers] = useState(
    profileQuestions.reduce((acc, q) => ({ ...acc, [q.id]: q.defaultAnswer }), {})
  );
  const [isEditing, setIsEditing] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [isPostsMediaExpanded, setIsPostsMediaExpanded] = useState(true);
  const [activeSlide, setActiveSlide] = useState(0);
  const [isCarouselPaused, setIsCarouselPaused] = useState(false);

  // Responsive configuration for carousel
  const responsive = [
    { minWidth: 1024.9, itemsToShow: 1.5 },
    { minWidth: 768, itemsToShow: 1.2 },
    { maxWidth: 767, itemsToShow: 1 },
  ];
  const [profileDescription, setProfileDescription] = useState(
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur."
  );
  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [imageLoading, setImageLoading] = useState(false);

  // CreatePost and CreateArticle modal state
  const [showPost, setShowPost] = useState(false);
  const [showArticle, setShowArticle] = useState(false);
  const [from, setFrom] = useState('');

  useEffect(() => {
    dispatch(loadPageDetail([]));
    if (pageUrl) {
      dispatch(pageDetailThunk(pageUrl, userState?.value?.data?._id));
    }
  }, [pageUrl, dispatch, userState?.value?.data?._id]);

  useEffect(() => {
    // When page data arrives, stop showing the loader.
    if (pageDetailState && pageDetailState.first_name) {
      setLoading(false);
    }

    const _urlParams: any = parseURLParams(window.location.href)
    if (
      pageDetailState && pageDetailState.first_name &&
      !isLoggedIn &&
      pageDetailState.privacy_status !== 'PUBLIC' &&
      !_urlParams?.adminId?.length
    ) {
      navigate(RouteConstants.REGISTER);
    }
  }, [pageDetailState, isLoggedIn, navigate, pageUrl]);

  // Force re-render when user image is updated
  useEffect(() => {
    // This effect will trigger when the user image changes
    console.log('User image updated:', userState?.value?.data?.image);
  }, [userState?.value?.data?.image]);

  // Auto-play carousel
  useEffect(() => {
    if (!isCarouselPaused && !isEditing) {
      const interval = setInterval(() => {
        setActiveSlide(prev => {
          const nextSlide = (prev + 1) % profileQuestions.length;
          return nextSlide;
        });
      }, 4000); // Change slide every 4 seconds

      return () => clearInterval(interval);
    }
  }, [isCarouselPaused, isEditing, profileQuestions.length]);

  const handleAnswerChange = (questionId: number, value: string) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: value
    }));
  };

  const handleDescriptionChange = (value: string) => {
    setProfileDescription(value);
  };

  const toggleDescriptionEdit = () => {
    setIsEditingDescription(!isEditingDescription);
  };

  const handleGoBack = () => {
    navigate('/mypages');
  };

  // CreatePost and CreateArticle modal handlers
  const handleShowPost = (postType: string) => {
    setFrom(postType);
    setShowPost(true);
  };

  const handleShowArticle = (postType: string) => {
    setFrom(postType);
    setShowArticle(true);
  };

  const handleClosePost = () => {
    setShowPost(false);
    setFrom('');
  };

  const handleCloseArticle = () => {
    setShowArticle(false);
    setFrom('');
  };

  const togglePostsMedia = () => {
    setIsPostsMediaExpanded(!isPostsMediaExpanded);
  };

  const goToSlide = (index: number) => {
    setActiveSlide(index);
  };

  const handleCarouselMouseEnter = () => {
    setIsCarouselPaused(true);
  };

  const handleCarouselMouseLeave = () => {
    setIsCarouselPaused(false);
  };

  // Gallery functionality (moved from FeaturesNav)
  const canAction = () => {
    if (!userState?.value?.data?._id) {
      loginRedirect();
    }

    if (
      pageDetailState?.belongsTo?._id === userState?.value?.data?._id ||
      pageDetailState?.subscribtion_status === 'APPROVED'
    ) {
      return true;
    } else {
      return false;
    }
  };

  const isBlur = () => {
    return (
      pageDetailState.privacy_status === 'PRIVATE' &&
      pageDetailState?.belongsTo?._id !== userState?.value?.data?._id &&
      pageDetailState?.subscribtion_status !== 'APPROVED'
    );
  };

  const loginRedirect = () => {
    navigate(RouteConstants.LOGIN);
  };

  const handleGalleryClick = () => {
    if (!userState?.value?.data?._id) {
      loginRedirect();
      return;
    }
    if (!isBlur()) {
      if (canAction()) {
        dispatch(setActiveSideSlug('gallery-add-page'));
        dispatch(setSidePanel({
          panelBody: 'Gallery',
          status: true,
        }));
        dispatch(pageGetGallleryThunk(pageDetailState?._id));
      } else {
        dispatch(addPageAction('show-subsciption-step'));
      }
    }
  };

  if (loading || !pageDetailState) {
    return <Loader />;
  }

  return (
    <div className="profile-page">
      <div className="back-button-container">
        <button onClick={handleGoBack} className="back-button" title="Go Back">
          <i className="fa fa-arrow-left"></i>
        </button>
      </div>
      {isPageOwner && (
        <div className="profile-header-bar">
          <button className="back-button" onClick={handleGoBack}>
            <i className="fa fa-arrow-left"></i>
            Back to My Pages
          </button>
          <button
            className="edit-profile-btn"
            onClick={() => setIsEditing(isEditing ? null : -1)}
          >
            <i className="fa fa-edit"></i>
            {isEditing ? 'Done' : 'Edit Profile'}
          </button>
        </div>
      )}
      <div className="profile-body">
        <div className="profile-content">
          <div className="profile-header">
            <div className={`profile-image ${imageLoading ? 'loading' : ''}`}>
              {(() => {
                // Determine which image to show based on ownership and available data
                let profileImageUrl = null;

                if (isPageOwner) {
                  // For page owner, prioritize user image, then page image
                  profileImageUrl = userState?.value?.data?.image || pageDetailState?.image;
                } else {
                  // For non-owners, prioritize page image, then user image
                  profileImageUrl = pageDetailState?.image || pageDetailState?.belongsTo?.image;
                }

                // Debug log to help troubleshoot image loading
                console.log('Profile Image Debug:', {
                  isPageOwner,
                  userImage: userState?.value?.data?.image,
                  pageImage: pageDetailState?.image,
                  belongsToImage: pageDetailState?.belongsTo?.image,
                  selectedImage: profileImageUrl
                });

                return profileImageUrl ? (
                  <>
                    <img
                      src={profileImageUrl}
                      alt="Profile"
                      onLoadStart={() => {
                        setImageLoading(true);
                      }}
                      onLoad={(e) => {
                        console.log('Profile image loaded successfully:', profileImageUrl);
                        setImageLoading(false);
                        // Hide any fallback initial that might be showing
                        const fallback = e.currentTarget.parentElement?.querySelector('.profile-initial');
                        if (fallback) {
                          fallback.style.display = 'none';
                        }
                      }}
                      onError={(e) => {
                        console.error('Failed to load profile image:', profileImageUrl);
                        setImageLoading(false);
                        e.currentTarget.style.display = 'none';
                        // Show the fallback initial
                        const fallback = e.currentTarget.parentElement?.querySelector('.profile-initial');
                        if (fallback) {
                          fallback.style.display = 'flex';
                        }
                      }}
                    />
                    <div className="profile-initial" style={{ display: 'none' }}>
                      {pageDetailState?.first_name?.charAt(0) || pageDetailState?.belongsTo?.first_name?.charAt(0) || 'U'}
                    </div>
                  </>
                ) : (
                  <div className="profile-initial">
                    {pageDetailState?.first_name?.charAt(0) || pageDetailState?.belongsTo?.first_name?.charAt(0) || 'U'}
                  </div>
                );
              })()}
            </div>
            <div className="profile-info">
              {loading ? (
                <div className="profile-loader">
                  <Loader />
                </div>
              ) : (
                <>
                  <h2>
                    {(pageDetailState?.first_name || pageDetailState?.last_name)
                      ? `${pageDetailState?.first_name ?? ''}${pageDetailState?.last_name ? ' ' + pageDetailState?.last_name : ''}`.trim()
                      : 'User Name'}
                  </h2>
                  {isLoggedIn && (
                    <p className="email">{userState?.value?.data?.email}</p>
                  )}
                  <div className="profile-description">
                    {isEditingDescription ? (
                      <div className="description-edit">
                        <textarea
                          value={profileDescription}
                          onChange={(e) => handleDescriptionChange(e.target.value)}
                          placeholder="Tell us about yourself..."
                          rows={4}
                          className="description-textarea"
                        />
                        <div className="description-actions">
                          <button
                            className="save-btn"
                            onClick={toggleDescriptionEdit}
                          >
                            Save
                          </button>
                          <button
                            className="cancel-btn"
                            onClick={toggleDescriptionEdit}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="description-display">
                        <p className="description-text">{profileDescription}</p>
                        {isPageOwner && (
                          <button
                            className="edit-description-btn"
                            onClick={toggleDescriptionEdit}
                            title="Edit description"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="qa-section">
            {/* <h3>Get to Know Me</h3> */}
            <div
              className="qa-carousel-wrapper"
              // onMouseEnter={handleCarouselMouseEnter}/
              onMouseLeave={handleCarouselMouseLeave}
            >
              <Carousel
                containerProps={{
                  style: {
                    width: '100%',
                    justifyContent: 'space-between',
                    userSelect: 'text',
                  },
                  className: 'qa-carousel-container',
                }}
                infinite={false}
                activeSlideIndex={activeSlide}
                onRequestChange={setActiveSlide}
                forwardBtnProps={{
                  children: <i className="fa fa-arrow-right"></i>,
                  className: 'control next',
                }}
                backwardBtnProps={{
                  children: <i className="fa fa-arrow-left"></i>,
                  className: 'control prev',
                }}
                dotsNav={{
                  show: false,
                }}
                speed={100}
                responsiveProps={responsive}
                preventScrollOnSwipe={true}
              >
                {profileQuestions.map((q, index) => (
                  <div
                    key={q.id}
                    className="qa-card-item"
                  >
                    <div className="qa-card">
                      <h4>{isEditing === q.id ? q.original : q.firstPerson}</h4>
                      <div className="qa-content">
                        {isEditing === q.id ? (
                          <textarea
                            value={answers[q.id]}
                            onChange={(e) => handleAnswerChange(q.id, e.target.value)}
                            rows={3}
                            placeholder="Share your answer..."
                            onFocus={handleCarouselMouseEnter}
                            onBlur={handleCarouselMouseLeave}
                          />
                        ) : (
                          <p onClick={() => isPageOwner && setIsEditing(q.id)}>
                            {answers[q.id]}
                            {isPageOwner && (
                              <i className="fa fa-edit edit-icon"></i>
                            )}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
          </div>

          {/* Create Post full width */}
          {isLoggedIn && (
            <div className="center-section-wrapper">
              {/* This header is ALWAYS visible */}
              <div className="section-header" onClick={() => {
                // Open post modal
                handleShowPost('description');
              }}>
                <h3>Start Creating Your Post</h3>
                <span className="toggle-arrow" title="Click to toggle">
                  <i className="fa fa-play"></i>
                </span>
              </div>
            </div>
          )}

          {/* Create Article full width */}
          {isLoggedIn && (
            <div className="center-section-wrapper">
              {/* This header is ALWAYS visible */}
              <div className="section-header" onClick={() => {
                // Open article modal
                handleShowArticle('description');
              }}>
                <h3>Create Article</h3>
                <span className="toggle-arrow" title="Click to toggle">
                  Start Writing
                </span>
              </div>
            </div>
          )}

          {/* Gallery Button - Full Width */}
          <div className="center-section-wrapper">
            <div className="section-header" onClick={handleGalleryClick}>
              <h3>Photos and Videos</h3>
              <span className="toggle-arrow" title="Click to toggle">
               Show {pageDetailState?.counts?.gallery || 0} items
              </span>
            </div>
          </div>

          {/* Center Section Content */}
          <div className="center-section-wrapper">
            {/* This header is ALWAYS visible */}
            <div className="section-header" onClick={togglePostsMedia}>
              <h3>Recent Activity</h3>
              <span className="toggle-arrow" title="Click to toggle">
                {isPostsMediaExpanded ? '▲' : '▼'}
              </span>
            </div>

            {/* This content is conditionally rendered */}
            {isPostsMediaExpanded && (
              <div className="center-section-content">
                <CenterSection
                  component={{
                    midView: [<CreatePostSec key="create-post-sec" />]
                  }}
                />

                {/* Recent Posts Carousel */}
                {pageDetailState?.mediaPosts?.length > 0 && (
                  <div className="recent-posts-section">
                    <div className="section-header">
                      <h3>Recent Posts</h3>
                      <div className="toggle-arrow">
                        <i className="fa fa-play"></i>
                      </div>
                    </div>
                    <Carousel
                      responsive={responsive}
                      infinite={true}
                      showDots={true}
                      renderButtonGroupOutside={true}
                      customButtonGroup={<CustomButtonGroup />}
                      arrows={false}
                      renderDotsOutside={true}
                      customDot={<CustomDot />}
                    >
                      {pageDetailState?.mediaPosts?.map((post, index) => (
                        <div key={index} className="post-card">
                          <div className="post-image">
                            <img src={post.media[0]?.url} alt={post.caption} />
                          </div>
                          <div className="post-content">
                            <h4 className="post-title">{post.caption}</h4>
                            <div className="post-meta">
                              <span className="post-date">{formatDate(post.createdAt)}</span>
                              <a href={`/post/${post._id}`} className="view-post">View Post</a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Carousel>
                  </div>
                )}

                {/* Recent Articles Carousel */}
                {pageDetailState?.articles?.length > 0 && (
                  <div className="recent-articles-section">
                    <div className="section-header">
                      <h3>Recent Articles</h3>
                      <div className="toggle-arrow">
                        <i className="fa fa-play"></i>
                      </div>
                    </div>
                    <Carousel
                      responsive={responsive}
                      infinite={true}
                      showDots={true}
                      renderButtonGroupOutside={true}
                      customButtonGroup={<CustomButtonGroup />}
                      arrows={false}
                      renderDotsOutside={true}
                      customDot={<CustomDot />}
                    >
                      {pageDetailState?.articles?.map((article, index) => (
                        <div key={index} className="article-card">
                          <div className="article-image">
                            <img src={article.coverImage || article.images?.[0]?.url} alt={article.title} />
                          </div>
                          <div className="article-content">
                            <h4 className="article-title">{article.title}</h4>
                            <p className="article-excerpt">{article.excerpt || article.content?.substring(0, 100) + '...'}</p>
                            <div className="article-meta">
                              <span className="article-date">{formatDate(article.createdAt)}</span>
                              <a href={`/article/${article._id}`} className="read-more">Read More</a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Carousel>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* CreatePost Modal */}
      {isLoggedIn && showPost && (
        <CreatePost
          title="Create Post"
          show={showPost}
          handleClose={handleClosePost}
          from={from}
        />
      )}

      {/* CreateArticle Modal */}
      {isLoggedIn && showArticle && (
        <CreateArticle
          title="Create Article"
          show={showArticle}
          handleClose={handleCloseArticle}
          from={from}
        />
      )}

      {/* SidePanel for Gallery and other features */}
      <SidePanel
        Active={appMeta.sidepanel.status}
        handleClose={() => {
          dispatch(setSidePanel({ panelBody: '', status: false }));
          dispatch(setActiveSideSlug(''));
        }}
        setDeleteshow={() => {}}
        setDeleteType={() => {}}
      />
    </div>
  );
};

export default ProfilePage;





